import ProductType from "../types/enums/ProductType"
import SensorTypeCode from "../types/enums/SensorTypeCode"
import SubscriptionPlan from "../types/enums/SubscriptionPlan"
import SubscriptionPlanTitlesWithPrefix from "./SubscriptionPlanTitlesWithPrefix"

export const alertTypeOptions = [
  {
    label: "Air quality",
    value: "air_quality",
  },
  {
    label: "Offline",
    value: "offline",
  },
  {
    label: "Temperature",
    value: "temperature",
  },
  {
    label: "Humidity sensor malfunction",
    value: "humidity_sensor_malfunction",
  },
  {
    label: "Fan malfunction",
    value: "fan_malfunction",
  },
  {
    label: "Temperature sensor malfunction",
    value: "temperature_sensor_malfunction",
  },
  {
    label: "Ambient sensor malfunction",
    value: "ambient_sensor_malfunction",
  },
]

export const contractorAlertTypeOptions = alertTypeOptions.map(option => {
  if (option.value === "temperature") {
    return {
      label: "System Efficiency",
      value: "efficiency_issue",
    }
  }
  return option
})

export const alertStatusOptions = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Acknowledged",
    value: "acknowledged",
  },
  {
    label: "Frozen",
    value: "frozen",
  },
]

export const contractorDevicePhysicalStatusOptions = [
  {
    label: "In Inventory",
    value: "inventory",
  },
  {
    label: "Installed",
    value: "installed",
  },
  {
    label: "Missing",
    value: "missing",
  },
  {
    label: "Warranty",
    value: "warranty",
  },
  {
    label: "Damaged",
    value: "damaged",
  },
  {
    label: "Transferring",
    value: "transferring",
  },
  {
    label: "Pre-Installed",
    value: "preinstalled",
  },
]

export const contractorPerformanceTestStatusOptions = [
  {
    label: "Scheduled",
    value: "scheduled",
  },
  {
    label: "Rescheduled",
    value: "rescheduled",
  },
  {
    label: "Running",
    value: "running",
  },
  {
    label: "Passed",
    value: "passed",
  },
  {
    label: "Issue",
    value: "issue",
  },
]

export const contractorPerformanceTestHistoryStatusOptions = [
  {
    label: "Passed",
    value: "passed",
  },
  {
    label: "Issue",
    value: "issue",
  },
]

export const contractorMonitoringPerformanceTestStatusOptions = [
  {
    label: "Running",
    value: "running",
  },
  {
    label: "Passed",
    value: "passed",
  },
  {
    label: "Issue",
    value: "issue",
  },
]

export const deviceWorkStatusOptions = [
  {
    label: "Online",
    value: "online",
  },
  {
    label: "Offline",
    value: "offline",
  },
]

export const hvacOptions = [
  {
    label: "New",
    value: "new",
  },
  {
    label: "Existing",
    value: "existing",
  },
]

export const devicesAlertsOptions = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
]

export const devicesMembershipOptions = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
]

export const deviceSystemTypeOptions = [
  {
    label: "Traditional",
    value: "traditional",
  },
  {
    label: "Heat pump",
    value: "heat_pump",
  },
  {
    label: "Heat only",
    value: "heating",
  },
  {
    label: "Cool only",
    value: "cooling",
  },
  {
    label: "Dual fuel heating",
    value: "dual_fuel_heating",
  },
]

export const deviceAccessoriesOptions = [
  {
    label: "Humidifier",
    value: "humidifier",
  },
  {
    label: "Dehumidifier",
    value: "dehumidifier",
  },
  {
    label: "None",
    value: "none",
  },
]

export const optInOptions = [
  {
    label: "Opted In",
    value: "opted_in",
  },
  {
    label: "Opted Out",
    value: "opted_out",
  },
]

export const orderStatusOptions = [
  {
    label: "New",
    value: "new",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Denied",
    value: "denied",
  },
  {
    label: "Confirmed",
    value: "confirmed",
  },
  {
    label: "Packed",
    value: "packed",
  },
  {
    label: "Shipping",
    value: "shipping",
  },
]

export const orderStatusOptionsNew = [
  {
    label: "New",
    value: "new",
  },
  {
    label: "Denied",
    value: "denied",
  },
  {
    label: "Confirmed",
    value: "confirmed",
  },
  {
    label: "Packed",
    value: "packed",
  },
  {
    label: "Shipping",
    value: "shipping",
  },
  {
    label: "Fulfilled",
    value: "archived",
  },
]

export const productTypeOptions = [
  {
    label: "Nuve V1 Thermostats",
    value: ProductType.Thermostat,
  },
  {
    label: "Nuve V2 Thermostats",
    value: ProductType.ThermostatV2,
  },
  {
    label: "C Wire Adapters (CWA)",
    value: ProductType.CWA,
  },
  {
    label: "Temperature / Humidity Sensors (THS)",
    value: ProductType.THS,
  },
  {
    label: "Water Leakage Sensors (WLS)",
    value: ProductType.WLS,
  },
]

export const sensorTypeOptions = [
  {
    label: "THS",
    value: String(SensorTypeCode.THS),
  },
  {
    label: "WLS",
    value: String(SensorTypeCode.WLS),
  },
]

export const sensorWorkStatusOptions = [
  {
    label: "Connected",
    value: "true",
  },
  {
    label: "Disconnected",
    value: "false",
  },
]

export const contractorSubscriptionNewOptions = [
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.START],
    value: SubscriptionPlan.START,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.SUPREME],
    value: SubscriptionPlan.SUPREME,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.BASIC_DEC_2025],
    value: SubscriptionPlan.BASIC_DEC_2025,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.BASIC_OCT_2025],
    value: SubscriptionPlan.BASIC_OCT_2025,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.BASIC_JULY_2026],
    value: SubscriptionPlan.BASIC_JULY_2026,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.BASIC_MAY_2026],
    value: SubscriptionPlan.BASIC_MAY_2026,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.GROWTH],
    value: SubscriptionPlan.GROWTH,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.GROW_MARCH_2026],
    value: SubscriptionPlan.GROW_MARCH_2026,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.NETWORK],
    value: SubscriptionPlan.NETWORK,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.NETWORK_JULY_2026],
    value: SubscriptionPlan.NETWORK_JULY_2026,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.E_PLUS],
    value: SubscriptionPlan.E_PLUS,
  },
]

export const contractorSubscriptionPlanOptions = [
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.GO],
    value: SubscriptionPlan.GO,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.BASIC],
    value: SubscriptionPlan.BASIC,
  },
  ...contractorSubscriptionNewOptions,
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.CONNECT],
    value: SubscriptionPlan.CONNECT,
  },
]

export const allContractorSubscriptionPlanOptions = [
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.GO],
    value: SubscriptionPlan.GO,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.BASIC],
    value: SubscriptionPlan.BASIC,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.BASIC_MAY_2025],
    value: SubscriptionPlan.BASIC_MAY_2025,
  },
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.PLUS],
    value: SubscriptionPlan.PLUS,
  },
  ...contractorSubscriptionNewOptions,
  {
    label: SubscriptionPlanTitlesWithPrefix[SubscriptionPlan.CONNECT],
    value: SubscriptionPlan.CONNECT,
  },
]

export const contractorStatusOptions = [
  {
    label: "Enabled",
    value: "1",
  },
  {
    label: "Disabled",
    value: "0",
  },
]

export const vendorDevicePhysicalStatusOptions = [
  {
    label: "In Stock",
    value: "stocked",
  },
  {
    label: "In Inventory",
    value: "inventory",
  },
  {
    label: "Installed",
    value: "installed",
  },
  {
    label: "Missing",
    value: "missing",
  },
  {
    label: "Production",
    value: "production",
  },
  {
    label: "Warranty",
    value: "warranty",
  },
  {
    label: "Damaged",
    value: "damaged",
  },
  {
    label: "Packed",
    value: "packed",
  },
  {
    label: "Repackaged",
    value: "repackaged",
  },
  {
    label: "Returned",
    value: "returned",
  },
  {
    label: "Refurbished",
    value: "refurbished",
  },
  {
    label: "Pre-Installed",
    value: "preinstalled",
  },
  {
    label: "Transferring",
    value: "transferring",
  },
]

export const vendorDeviceRedFlagOptions = [
  {
    label: "Yes",
    value: "1",
  },
  {
    label: "No",
    value: "0",
  },
]

export const vendorDeviceRedFlagTypeOptions = [
  {
    label: "No Contractor & Installed",
    value: "No Contractor & Installed",
  },
  {
    label: "Warranty & online",
    value: "Warranty & online",
  },
  {
    label: "Missing & online",
    value: "Missing & online",
  },
  {
    label: "Damaged & online",
    value: "Damaged & online",
  },
  {
    label: "Installed without ST",
    value: "Installed without ST",
  },
  {
    label: "Installed over installed",
    value: "Installed over installed",
  },
  {
    label: "Zip Code not found",
    value: "Zip Code not found",
  },
  // {
  //   label: "Wrong location",
  //   value: "Wrong location",
  // },
]

export const userRoleOptions = [
  {
    label: "Vendor Admin",
    value: "VENDOR_ADMIN",
  },
  {
    label: "Vendor Sales Admin",
    value: "VENDOR_SALES_MANAGER",
  },
  {
    label: "Warehouse Manager",
    value: "WAREHOUSE_MANAGER",
  },
]

export const contractorUserRoleOptions = [
  {
    label: "Admin",
    value: "CONTRACTOR_ADMIN",
  },
  {
    label: "Manager",
    value: "CONTRACTOR_ENGINEER",
  },
  {
    label: "Technician",
    value: "CONTRACTOR_TECHNICIAN",
  },
]

export const warehouseManagerOrderStatusOptions = [
  {
    label: "Confirmed",
    value: "confirmed",
  },
  {
    label: "Packed",
    value: "packed",
  },
  {
    label: "Shipping",
    value: "shipping",
  },
]

export const warehouseManagerDeviceStatusOptions = [
  {
    label: "In Stock",
    value: "stocked",
  },
  {
    label: "Missing",
    value: "missing",
  },
  {
    label: "Warranty",
    value: "warranty",
  },
  {
    label: "Damaged",
    value: "damaged",
  },
  {
    label: "Packed",
    value: "packed",
  },
  {
    label: "Repackaged",
    value: "repackaged",
  },
  {
    label: "Returned",
    value: "returned",
  },
  {
    label: "Refurbished",
    value: "refurbished",
  },
]

export const CountryOptions = [
  {
    label: "United States",
    value: "United States",
  },
  {
    label: "Canada",
    value: "Canada",
  },
  {
    label: "Australia",
    value: "Australia",
  },
]

export const MessageDeliveryStatusOptions = [
  {
    label: "Delivered",
    value: "delivered",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Failed",
    value: "failed",
  },
]

export const yesNoOptions = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
]
